import { Subscriber } from '@/components/campaigner/helper'
export default {
  data () {
    return {
    }
  },
  methods: {
    addSubscriber (u, listid) {
      var data = new Subscriber(u, (listid || '8800a565e7'))
      return new Promise((resolve, reject) => {
        this.$http
        .post('service/campaign/subscribe', data)
        .then(response => {
          if (response.data) {
            resolve(response.data)
          } else {
            resolve([])
          }
        })
        .catch(function (error) {
          reject(error);
        });
      });
    },
    removeSubscriber (u, listid) {
      var data = {
        id: u.subscribed_id,
        list: (listid || '8800a565e7')
      }
      return new Promise((resolve, reject) => {
        this.$http
        .post('service/campaign/unsubscribe', data)
        .then(response => {
          if (response.data) {
            resolve(response.data)
          } else {
            resolve([])
          }
        })
        .catch(function (error) {
          reject(error);
        });
      });
    },
    getMailChimpData (what, id) {
      var param = id ? '/' + id : '';
      return new Promise((resolve, reject) => {
        this.$http
        .get('service/campaign/data/' + what + param)
        .then(response => {
          if (response.data) {
            resolve(response.data)
          } else {
            resolve([])
          }
        })
        .catch(function (error) {
          reject(error);
        });
      });
    }
  }
}
